import * as fetcher from "../fetcher";
import { type OrderAttachment } from "./types";

export const downloadAttachment = async (
  market: string,
  language: string,
  attachment: OrderAttachment,
  isDraft?: boolean
) => {
  const url = isDraft
    ? `${market}/${language}/?fileName=${attachment.fileReference}`
    : `${market}/${language}/?fileName=${attachment.originalFileName}&performSapiOperation=true&attachmentLocation=${attachment.attachmentLocation}`;

  const result = await fetcher.saljaDownloadAttachment.download(url);

  return result;
};
